import React, { useEffect, useState } from 'react';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  ACTIVITY_CALENDAR_CATEGORY_EDIT,
  ACTIVITY_CATEGORY_TAB_LIST,
} from '../../../../../constants/ActivityCalendarConst';
import { useSelector } from 'react-redux';
import { activityCalendarSelector, allActivityCalendarCategoriesSelector } from '../../../cmsSlice';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_ACTIVITYCALENDAR,
} from '../../../../../constants/RoleConsts';

const ActivityCalendarCategoryView = (props) => {
  const { activityCalendarCategory, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedCategory, setSelectedCategory] = useState(activityCalendarCategory);
  const originalActivityCalendarCategories = useSelector(allActivityCalendarCategoriesSelector);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (activityCalendarCategory && Array.isArray(originalActivityCalendarCategories)) {
      const foundCategory = originalActivityCalendarCategories?.find(
        (cat) => cat?.id === activityCalendarCategory?.id,
      );
      setSelectedCategory(foundCategory || null);
    }
  }, [activityCalendarCategory, originalActivityCalendarCategories]);

  const renderScreen = () => {
    return (
      <>
        <div className='mx-4'>
          {tabValue === 0 && (
            <>
              <div className='col-md-6 mt-5'>
                <div className='details-label'>Category Name</div>
                <div className='details-value preview-breaks'>{selectedCategory?.name}</div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Category Code</div>
                <div className='details-value'>{selectedCategory?.categoryCode}</div>
              </div>
            </>
          )}
          {tabValue === 1 && (
            <>
              <div className='row pt-4'>
                <MediaViewer
                  images={selectedCategory.images}
                  videos={selectedCategory.videos}
                  gifs={selectedCategory.gifs}
                  enabledMediaTabs={['image']}
                />
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  const onClickEdit = (event) => {
    toggleDrawer(ACTIVITY_CALENDAR_CATEGORY_EDIT, true, selectedCategory);
  };

  return (
    <>
      {selectedCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={ACTIVITY_CATEGORY_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedCategory?.name}
          createdUserId={selectedCategory?.createdBy}
          isEditable={
            permissions?.[RBAC_TYPE_CMS_ACTIVITYCALENDAR] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-5'
        />
      )}
    </>
  );
};

export default ActivityCalendarCategoryView;
